import React from 'react';
import FrontRecapitulatif from './recapitulatif';
import FrontDocuments from './documents';
import waiter from '../img/wait.svg'
import FrontFooter from './footer'
import sablier from '../img/sablier.png'
import options_demo from '../img/options_demo.png'
import FrontProgress from './progress';

export default class FrontSubscribeSolly extends React.Component {
    
    constructor(props) {
        super(props);
        this.state = {error:false}
    }

    componentDidMount() {
        this.props.api.post(
            {
                action:'subscribe_solly',
                id:this.props.id
            },
            (res)=>{
                // onSuccess
                if ( res.redirect ) {
                    window.location = res.redirect
                }
            },
            ()=>{
                // onError
                this.setState({error:true})
            }
        )
    }

    render() {
        const container = {
            devis:this.props.devis,
            changeParams:this.props.changeParams,
            setPage: this.props.setPage
        }
        return <>
        {this.state.error
            ? <FrontProgress comparateursCompleted={true} setPage={this.props.setPage} page={this.props.page} topRef={this.props.topRef}/>
            : <></>
        }
        <div className="container narrow" ref={this.props.topRef}>
            <div className="contentbox front_form">
                <div className="contentvbox">

                    {this.state.error
                        ? <>
                            <h2>
                            Désolé, nous n'avons pas pu contacter l'assureur final.<br/>
                            <b>Nous vous invitons à réessayer ultérieurement ou choisir une autre offre.</b>
                            </h2>

                        </>
                        : <>
                            {/*<img src={sablier} className="image_title"/>*/}
                            <p>
                                &nbsp;
                                <br/>
                                <img src={waiter} className="little_waiter"/>
                            </p>
                            <h2>Vous allez être dirigé dans quelques secondes sur l'offre<br/>
                            <b>Assur Bon Plan ...</b></h2>
                            <div className="red_notice">
                                ⓘ Avant de finaliser votre souscription<br/>
                                Merci de bien sélectionner les options 😊
                            </div>
                            <img src={options_demo} className="centered_wide_image"/>
                        </>
                    }
                </div>
            </div>

            </div>
            <FrontFooter/>

        </>
    }
}